module.exports = __webpack_public_path__ + "img/m-gongyingshang.7e77f443.svg";